<template>
	<b-modal id="eventTicketGroupModal" size="lg" :title="title" no-close-on-backdrop hide-footer @close="close">
		<div class="p-3" v-if="opened">
			<EventTicketGroupForm :event="event" :group="group" @updated="close()" />
		</div>
	</b-modal>
</template>
<script>
import EventTicketGroupForm from "./EventTicketGroupForm"

export default {
	name: "EventTicketGroupModalForm",
	components: {
		EventTicketGroupForm
	},
	props: {
		event: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			loading: true,
			saving: false,
			opened: false,
			group: null,
			title: "Crear tipo de entrada",
			action: "create"
		}
	},

	methods: {
		async open(item) {
			this.title = "Crear tipo de entrada"
			this.action = "create"
			this.opened = false
			this.group = null

			if (item) {
				this.title = "Editar tipo de entrada"
				this.action = "update"
				this.group = item
			}
			this.opened = true
			this.$bvModal.show("eventTicketGroupModal")
		},
		close() {
			this.$emit("updated")
			this.$bvModal.hide("eventTicketGroupModal")
		}
	}
}
</script>
